var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticStyle:{"text-align":"center","margin-top":"200px"}},[_vm._v("欢迎登陆邮箱")])}
var staticRenderFns = []

export { render, staticRenderFns }